// extracted by mini-css-extract-plugin
export default {"ButtonSection":"gridPessoas_ButtonSection__bSQyn"};